import { useQuery } from 'react-query';
import { getRosterStateSettings } from 'RestAPIs/roster/state-settings';
import { showErrorSnackbar } from 'components/shared/Snackbar';

const useGetRosterStateSettings = (costCenterId: number) =>
  useQuery(['rosterStateSettings', costCenterId], async () => {
    try {
      const response = await getRosterStateSettings({ costCenterId });
      return response.data;
    } catch (error) {
      showErrorSnackbar();
      throw error;
    }
  });

export default useGetRosterStateSettings;
